import { Component } from './component.js';

export class PopupSurface extends Component {
  static defaultOptions = {
    componentName: 'PopupSurface',
    width: 700
  };

  constructor (options) {
    super($.extend({}, PopupSurface.defaultOptions, options));
    this.el.width(this.options.width);

    if (options.maxHeight) this.el.css('maxHeight', options.maxHeight);

    this.shim = $('<div class="ca-ui-popupsurface_shim"></div>');
    this.shim.on(
      'click',
      function () {
        if (!this.open) return;
        this.hide();
      }.bind(this)
    );

    /* $(document).on('click', function(e)
        {
            if(!this.open) return;

            console.log(e);
            alert('click');

            this.hide();
        }.bind(this)); */
  }

  show () {
    super.show();
    this.open = true;
    this.shim.show();
    this.el.parent().append(this.shim);
    this.el.addClass('open');
  }

  hide () {
    this.open = false;
    this.shim.hide();
    this.el.removeClass('open');
    setTimeout(
      function () {
        this.el.hide();
      }.bind(this),
      200
    );
  }

  toggle () {
    if (this.open) this.hide();
    else this.show();
  }
}
